const CarouselCardInner: React.CSSProperties = {
    width: '100%',
    height: '131px',
    objectFit: 'cover',
    textAlign: 'center',
    justifyContent: 'center',
    userSelect: 'none'
};

export default CarouselCardInner;
